import { User } from "../../shared/models/user.model";
//import {AuthActions, AuthActionTypes} from "./auth.actions";
import * as AuthActions from "./auth.actions";

export interface State {
  //isAuthenticated: boolean;
  user: User;
}

const initialState: State = {
  //isAuthenticated: false,
  user: null
};


export function authReducer(
  state: State = initialState,
  action: AuthActions.AuthActions) {
  switch (action.type) {
    case AuthActions.LOGIN:
      const user = new User(
        action.payload.uid,
        action.payload.username,
        action.payload.email,
        action.payload.role,
        action.payload.refresh_token,
        action.payload.access_token,
        action.payload.id_token,
        action.payload._tokenExpirationDate,
        action.payload.exp
      );
      return {
        ...state,
        user: user
      };
    case AuthActions.LOGOUT:
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
}
